import { Grid2, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { WeldTest } from "@/shared/models/WeldTest";
import { useTableData } from "../hooks/useTableData";
import { WeldTestPhotoModal } from "./WeldTestPhotoModal";

type Props = {
	isLoading: boolean;
	rows: WeldTest[];
	onEdit: (test: WeldTest) => void;
	onDelete: (test: WeldTest) => void;
};

export const WeldTestsTable = ({
	isLoading,
	rows,
	onEdit,
	onDelete,
}: Props) => {
	const [photo, setPhoto] = useState<{ title: string; path: string } | null>(
		null,
	);

	const { columnDefs } = useTableData({
		onShowPhoto: (title, path) => setPhoto({ title, path }),
		onEdit,
		onDelete,
	});

	return (
		<>
			<Grid2
				container
				size={{ md: 12, xs: 12 }}
				sx={{
					height: "65vh",
					minHeight: "65vh",
				}}
				component={Paper}
				elevation={2}
			>
				<Grid2 size={{ md: 12, xs: 12 }} height={"100%"}>
					<AgGridReact<WeldTest>
						loading={isLoading}
						animateRows
						suppressContextMenu
						rowData={rows}
						columnDefs={columnDefs}
						onRowDoubleClicked={(e) => e.data && onEdit(e.data)}
						getRowId={(params) => `${params.data.TestId}`}
						loadingOverlayComponent={CenteredLazyLoading}
					/>
				</Grid2>
			</Grid2>
			<WeldTestPhotoModal
				open={photo !== null}
				title={photo?.title ?? ""}
				path={photo?.path ?? null}
				onClose={() => setPhoto(null)}
			/>
		</>
	);
};
